<template>
  <div class="modal-wrapper" @click.stop="$emit('mask')">
    <div class="modal-content">
      <div class="content-title">
        <div>{{ option.title }}</div>
      </div>
      <div class="content-text">{{ option.descript }}</div>
      <div class="hr"></div>
      <div class="operate-button">
        <button
          v-show="option.showCancel"
          class="button cancel-button"
          @click.stop="$emit('handleCancel')"
        >
          {{ option.cancelText }}
        </button>
        <button class="button confirm-button" @click.stop="$emit('handleSubmit')">
          {{ option.confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { ModalOption } from './confirm';

@Component({})
export default class MbView extends Vue {
  @Prop({ type: Object }) option: ModalOption;
  @Prop({ type: String }) iconByType: ModalOption;
}
</script>

<style scoped>
.modal-wrapper {
  @apply fixed top-0 left-0 w-screen h-screen z-40;
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
/* pc */
.modal-content {
  @apply absolute top-1/2 left-1/2 bg-white w-5/6;
  border-radius: 8px;
  transform: translate(-50%, -50%);
}

.content-title {
  @apply flex items-center justify-center font-medium pt-10 px-8;
  color: #000;
  font-size: 17px;
}

.content-text {
  @apply mt-4 px-8 pb-10 flex items-center justify-center;
  color: rgba(63, 51, 86, 0.6);
  font-size: 14px;
}

/* button */
.hr {
  @apply w-full h-px;
  background-color: rgba(0, 0, 0, 0.1);
  transform: scaleY(0.5);
}
.button {
  @apply font-medium hover:opacity-80;
  font-size: 17px;
}
.operate-button {
  @apply w-full flex justify-between items-center;
}

.operate-button button {
  @apply w-full h-12 text-center;
}

.operate-button button:last-child {
  border-left-width: 0;
}
.cancel-button {
  @apply relative;
  color: #576b95;
}
.cancel-button::after {
  @apply absolute  top-0 right-0 inline-block h-full w-px;
  background-color: rgba(0, 0, 0, 0.1);
  transform: scaleX(0.5);
  content: ' ';
}
</style>
